import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#2e3742';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[500],
    light: colors.blue[50],
  },
  secondary: {
    contrastText: white,
    dark: colors.teal[900],
    main: colors.teal[500],
    light: colors.teal[50],
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    link: colors.blue[700],
    primary: '#D0D3D4',
    secondary: '#4a494b',
  },
  background: {
    default: '#0A0811',
    paper: '#2C2C2C',
  },
  icon: '#4a494b',
  divider: '#121212',
  cardTitle: '#2e3742',
  chartTitle: '#34495E',
};
